import * as React from "react";
import axios from "axios";
import ColumnMenu from "../../../Shared/GridComponents/ColumnMenu";
import { CellRender, GridNoRecord, StatusCell } from "../../../Shared/GridComponents/CommonComponents";
import { Grid, GridCellProps, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { State, toODataString } from "@progress/kendo-data-query";
import { CustomMenu, DefaultActions, DetailColumnCell, ViewMoreComponent } from "./GlobalActions";
import { initialDataState, history, localDateTime, successToastr } from "../../../../HelperMethods";
import RowActions from "../../../Shared/Workflow/RowActions";
import { EXTEND_ASSIGNMENT } from "../../../Shared/ApiUrls";
import { Dialog } from "@progress/kendo-react-dialogs";
import ExtensionStatusBar from "../../../Shared/ExtensionStatusCard/ExtensionStatusBar";
import RejectModal from "../../../Shared/RejectModal";
import { ASSIGNMENT_EXTENSION_CANCELLED_MSG, ASSIGNMENT_EXTENSION_CLOSED_MSG, ASSIGNMENT_EXTENSION_UPDATED_SUCCESS_MSG, CANCEL_ASSIGNMENT_EXTENSION_MSG, CLOSE_ASSIGNMENT_EXTENSION_MSG } from "../../../Shared/AppMessages";
import { CandidateWorkflow, ExtensionActionStatuses } from "../../../Shared/AppConstants";

export interface AssignmentExtensionsProps {
    candSubmissionId: string;
    assignmentStatus: any;
    updateAssignmentStatus?: any;
}

export interface AssignmentExtensionsState {
    data: any;
    showLoader?: boolean;
    dataItem?: any;
    dataState: any;
    totalCount?: number;
    showExtensionHistoryModal?: boolean;
    showCancelModal?: boolean;
    showCloseModal?: boolean;
}

class AssignmentExtensions extends React.Component<
    AssignmentExtensionsProps,
    AssignmentExtensionsState
> {
    public dataItem: any;
    public actionId: any;
    public action: any;
    public eventName: any;
    public statusId: any;
    constructor(props: AssignmentExtensionsProps) {
        super(props);
        this.state = {
            data: [],
            dataState: initialDataState,
            showLoader: true,
        };
    }

    componentDidMount() {
        if (this.props.candSubmissionId != null) {
            this.getExtension(this.state.dataState);
        }
    }

    getExtension = (dataState) => {
        var queryStr = `${toODataString(dataState, { utcDates: true })}`;
        this.setState({ showLoader: true });
        axios.get(`api/candidates/${this.props.candSubmissionId}/assignmentextensions?${queryStr}`).then((res) => {
            console.log("res.data", res.data);
            this.setState({
                data: res.data,
                showLoader: false,
                dataState: dataState,
            });
            this.getExtensionCount(dataState);
        });
    };

    getExtensionCount = (dataState) => {
        var finalState: State = {
            ...dataState,
            take: null,
            skip: 0,
        };

        var queryStr = `${toODataString(finalState, { utcDates: true })}`;

        axios.get(`api/candidates/${this.props.candSubmissionId}/assignmentextensions?${queryStr}`).then((res:any) => {
            this.setState({
                totalCount: res.data.length
            });
        });
    };

    // expandChange = (dataItem) => {
    //     dataItem.expanded = !dataItem.expanded;
    //     this.forceUpdate();
    // };

    expandChange = (dataItem) => {
        const { data } = this.state;
        const extensionData = data.map((item) => {
          if (item === dataItem) {
            item.expanded = !item.expanded;
          }
          return item;
        });
        this.setState({
            data: extensionData
        });
    };

    onDataStateChange = (changeEvent) => {
        this.getExtension(changeEvent.dataState);
    };

    handleActionClick = (action, actionId, rowId, nextStateId?, eventName?, dataItem?) => {
        let change = {};
        let property = `show${action.replace(/ +/g, "").replace(".", "")}Modal`;
        change[property] = true;
        this.setState(change);
        this.dataItem = dataItem;
        this.actionId = actionId;
        this.statusId = nextStateId;
        this.action = action;
        this.eventName = eventName
    }

    RequestExtension = () => {
        history.push(`${EXTEND_ASSIGNMENT}${this.props.candSubmissionId}`);
    }

    ExpandCell = (props) => (
        <DetailColumnCell {...props} expandChange={this.expandChange.bind(this)} />
    );

    MyCustomCell = (props: GridCellProps) => (
        <RowActions {...props} wfCode={CandidateWorkflow.ASSIGNMENTEXTENSION}
            props={props}
            key={props.dataItem.candSubExtId}
            dataItem={props.dataItem}
            currentState={props.dataItem.status}
            entityId={props.dataItem.candSubExtId}
            rowId={props.dataItem.candSubExtId}
            handleClick={this.handleActionClick}
            defaultActions={DefaultActions(props)}
            isClientCheck={true}
            hideBtn={this.hideButton(props.dataItem.extStartDate, props.dataItem.extEndDate)} />
    );

    hideButton = (extStartDate, extEndDate) => {
        let startDate = new Date(new Date(extStartDate).setDate(new Date(extStartDate).getDate()));
        let endDate = new Date(new Date(extEndDate).setDate(new Date(extEndDate).getDate()));
        return startDate.setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0) &&
                    endDate.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)  ? ["Cancel"] : 
                    startDate.setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0) ? ["Close"] : null;
    }

    render() {
        return (
            <div className="row mt-3 mt-md-0">
                <div className="container-fluid">
                    <div className="cand-bill-rate" id="cand-bill-rate-responsive">
                        <Grid
                            style={{ height: "auto" }}
                            sortable={true}
                            onDataStateChange={this.onDataStateChange}
                            pageable={{ pageSizes: true }}
                            data={this.state.data}
                            {...this.state.dataState}
                            total={this.state.totalCount}
                            detail={ViewMoreComponent}
                            expandField="expanded"
                            className="kendo-grid-custom k-widget lastchild"
                        >
                            <GridNoRecords>
                                {GridNoRecord(this.state.showLoader)}
                            </GridNoRecords>
                            <GridColumn
                                field="extStartDate"
                                filter="date"
                                format="{0:d}"
                                editor="date"
                                title="Extension Start Date"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Extension Start Date")}
                            />
                            <GridColumn
                                field="extEndDate"
                                filter="date"
                                format="{0:d}"
                                editor="date"
                                title="Extension End Date"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Extension End Date")}
                            />
                            <GridColumn
                                field="reason"
                                title="Extension Reason"
                                cell={(props) => CellRender(props, "Extension Reason")}
                                columnMenu={ColumnMenu}
                            />
                            <GridColumn
                                field="requestedDate"
                                filter="date"
                                format="{0:d}"
                                editor="date"
                                title="Requested Date"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Requested Date")}
                            />
                            <GridColumn
                                field="requestedBy"
                                title="Requested By"
                                cell={(props) => CellRender(props, "Requested By")}
                                columnMenu={ColumnMenu}
                            />
                            <GridColumn
                                field="status"
                                width="160px"
                                title="Status"
                                cell={StatusCell}
                                columnMenu={ColumnMenu}
                            />
                            <GridColumn
                                title="Action"
                                sortable={false}
                                width="70px"
                                // cell={(props) => (
                                //     <RowActions
                                //         dataItem={props.dataItem}
                                //         currentState={""}
                                //         rowId={props.dataItem.candSubProjectionId}
                                //         handleClick={this.handleActionClick}
                                //         defaultActions={DefaultActions(props)}
                                //     />
                                // )}
                                cell={this.MyCustomCell}
                                headerCell={() => CustomMenu(this.RequestExtension, this.props.assignmentStatus)}
                            />
                            <GridColumn sortable={false} field="expanded"
                                width="100px" title="View More" cell={this.ExpandCell} />
                        </Grid>
                    </div>
                </div>
                {this.state.showExtensionHistoryModal && (
                    <div id="hold-position">
                        <Dialog className="col-12 width For-all-responsive-height">
                            <ExtensionStatusBar
                                dataItem={this.dataItem}
                                handleClose={() =>
                                    this.setState({ showExtensionHistoryModal: false })
                                }
                                statusLevel={1}
                            ></ExtensionStatusBar>
                        </Dialog>
                    </div>
                )}
                {this.state.showCancelModal && this.actionId && (
                    <RejectModal
                        action={this.action}
                        actionId={this.actionId}
                        message={CANCEL_ASSIGNMENT_EXTENSION_MSG()}
                        showModal={this.state.showCancelModal}
                        handleYes={(data) => 
                            this.updateExtension(this.dataItem, "showCancelModal", data)
                        }
                        handleNo={() => {
                            this.setState({ showCancelModal: false });
                        }}
                    />
                )}
                {this.state.showCloseModal && this.actionId && (
                    <RejectModal
                        action={this.action}
                        actionId={this.actionId}
                        message={CLOSE_ASSIGNMENT_EXTENSION_MSG()}
                        showModal={this.state.showCloseModal}
                        handleYes={(data) =>
                            this.updateExtension(this.dataItem, "showCloseModal", data)
                        }
                        handleNo={() => {
                            this.setState({ showCloseModal: false });
                        }}
                    />
                )}

            </div>
        );
    }
    updateExtension(dataItem,modal, props?) {
        this.setState({showLoader: true, data:[] })
        let data = {
            candSubmissionId: dataItem.candSubmissionId,
            candSubExtId: dataItem.candSubExtId,
            extStartDate: localDateTime(dataItem.extStartDate),
            extEndDate: localDateTime(dataItem.extEndDate),
            specialTerms: dataItem.specialTerms,
            statusId: this.statusId,
            eventName: this.eventName,
            actionId: this.actionId,
            action: this.action,
            ...props
        };

        if (dataItem.candSubmissionId && dataItem.candSubExtId) {
            const {candSubExtId } = dataItem;
            if (this.action == ExtensionActionStatuses.CANCEL || this.action == ExtensionActionStatuses.CLOSE) {
                if ((dataItem.extStartDate != undefined && dataItem.extStartDate != null) && (dataItem.extEndDate != undefined && dataItem.extEndDate != null)) {
                    axios.patch(`api/candidates/assignmentextension/${candSubExtId}`, JSON.stringify(data)).then((res) => {
                        this.action === ExtensionActionStatuses.CANCEL ? successToastr(ASSIGNMENT_EXTENSION_CANCELLED_MSG) : successToastr(ASSIGNMENT_EXTENSION_CLOSED_MSG);
                            this.setState({ showLoader: false })
                            this.getExtension(this.state.dataState);
                            if (this.props.updateAssignmentStatus){
                                this.props.updateAssignmentStatus();
                            }
                    }).catch(error => {
                        this.getExtension(this.state.dataState)
                        this.setState({ showLoader: false });
                    });
                }
                
            }
        }
        let change = {};
        change[modal] = false;
        this.setState(change);
    }
}
export default AssignmentExtensions;
